export const upload_cloud = () => (
  <path
    d="M16 16l-4-4m0 0l-4 4m4-4v9m8.39-2.61A5 5 0 0018 9h-1.26A8 8 0 103 16.3"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
